"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fmoneySpace = void 0;
var fmoney_1 = require("./fmoney");
/**
 * formatuje liczbę zmiennoprzecinkową do polskiego formatu
 * @param value liczba
 * @param forcezeros czy zachować zera ,00
 * @param precision do ilu miejsc po przecinku zaokrąglić, domyślnie 2
 */
function fmoneySpace(value, forcezeros, precision) {
    if (precision === void 0) { precision = 2; }
    var ext;
    if (typeof value !== 'string') {
        ext = (0, fmoney_1.default)(value, forcezeros, precision);
    }
    else {
        ext = value;
    }
    var parts = ext.split(',');
    var result = '';
    var partsLength = parts[0].length - 1;
    for (var i = 0; i <= partsLength; i++) {
        result = parts[0][partsLength - i] + result;
        if (i < partsLength && (i === 2 || i === 5 || i === 8 || i === 11)) {
            result = ' ' + result;
        }
    }
    if (parts.length > 1) {
        return result + ',' + parts[1];
    }
    else {
        return result;
    }
}
exports.fmoneySpace = fmoneySpace;
exports.default = fmoneySpace;
//# sourceMappingURL=fmoneySpace.js.map